/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import { useNavigate } from "react-router-dom";
import { getOptionsData, getStocksData } from "../data-tables/data/getData";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import SoftButton from "components/SoftButton";
import Grid from "@mui/material/Grid";
import InfoIcon from "@mui/icons-material/Info";
import { Button, Menu, MenuItem, Table, TableHead } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// Data
import dataTableData from "layouts/applications/data-tables/data/dataTableData";
import { useEffect, useState } from "react";

import { roundToTwo } from "layouts/Helper/helper";
import BackToButton from "components/CustomComponents";
import { OptionInfoPopup } from "components/CustomPopups/OptionPopups";
import { DisclaimerPopup } from "components/CustomPopups/InfoPopups";

import useAuth from "layouts/authentication/hooks/useAuth";
import { setPaymentPopup, useSoftUIController } from "context";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
import SoftTypography from "components/SoftTypography";

function DataTables() {
  // const [isLoading,setLoading] = useState(true);
  const [initialData, setData] = useState(dataTableData);
  const [firstLoad, setLoad] = useState(true);
  const [loading, setLoading] = useState(false);
  const [fullData, setFullData] = useState();
  const [infoPopup, toggleInfoPopup] = useState(false);
  const [popupAccessor, setPopupAccessor] = useState("");
  const [disclaimerPopup, setDisclaimerPopup] = useState(true);

  const { auth } = useAuth();
  const navigate = useNavigate();

  const [controller, dispatch] = useSoftUIController();
  const { paymentPopup } = controller;

  useEffect(() => {
    setLoading(true);
    handleOption();
    setDisclaimerPopup(true);
  }, []);

  const onClickView = (stockCode) => {
    if (!auth || !auth.plan?.plan_features.available.includes("gem_ranking"))
      setPaymentPopup(dispatch, { forStocks: true, on: !paymentPopup.on, isPaymentPopup: true });
    else navigate(`/dashboard/GEM/stocks-screener/${stockCode}`);
  };

  const handleOption = async () => {
    if (firstLoad) {
      setLoad(false);
      setLoading(true);
      let optionData = await getStocksData({ page: 1, perPage: 100 });

      if (!optionData || optionData === "error") optionData = [];

      // added to avoid inifite update to DOM
      setTimeout(() => {
        setFullData(optionData);
        setData(formatOptions(optionData));
        setLoading(false);
      }, 100);
    }
  };

  const formatOptions = (optionData) => {
    console.log(optionData);

    var final = [
      { Header: "GEM Strength", accessor: "gemStockRank" },
      { Header: "SYM", accessor: "symbol" },
      { Header: "Sector", accessor: "sector" },
      { Header: "Stock Price", accessor: "stockPrice" },
      // { Header: "Capital Needed", accessor: "CapitalNeeded" },
      // { Header: "Premium", accessor: "premium" },
      // { Header: "Min Return (%)", accessor: "minReturn" },
      // { Header: "Max Return (%)", accessor: "maxReturn" },
      { Header: "", accessor: "view_column", disableSortBy: true },
    ];

    const theTableData = optionData.data.map((options) => {
      let estimatedReturn = ((options.MaxProfit / options.MaxLoss) * 100).toFixed(2);

      return {
        gemStockRank: options.GEM_Rank,
        symbol: options.symbol,
        sector: options.Sector,
        CapitalNeeded: options.MaxLoss,
        premium: options.MaxProfit,
        stockPrice: options.last_close,
        estimatedReturn: estimatedReturn,
      };
    });

    const optionsDataTable = {
      columns: final.map((header) => {
        return { Header: header.Header, accessor: header.accessor, disableSortBy: header.disableSortBy ? true : false };
      }),
      rows: theTableData,
    };

    return optionsDataTable;
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <SoftBox pt={3} pb={3}>
        <Card style={{ padding: "20px" }}>
          <SoftTypography style={{ textAlign: "center" }} mb={2}>
            GEM 100 v/s SPX
          </SoftTypography>
          <table>
            <tr style={{background: "#eee"}}>
              <th></th>
              <th style={{textAlign: "left"}}>2020</th>
              <th style={{textAlign: "left"}}>2021</th>
              <th style={{textAlign: "left"}}>2022</th>
              <th style={{textAlign: "left"}}>2023</th>
              <th style={{textAlign: "left"}}>2024</th>
            </tr>
            <tr>
              <td>GEM 100</td>
              <td>0.88%</td>
              <td>47.80%</td>
              <td>-8.11%</td>
              <td>42.25%</td>
              <td>32.07%</td>
            </tr>
            <tr>
              <td>SPX</td>
              <td>14.79%</td>
              <td>24.58%</td>
              <td>-17.95%</td>
              <td>22.48%</td>
              <td>22.13%</td>
            </tr>
            <tr>
              <td></td>
              <td style={{ backgroundColor: "#ead3da"}}>Bad</td>
              <td style={{ backgroundColor: "#d9ead3"}}>Good</td>
              <td style={{ backgroundColor: "#d9ead3"}}>Good</td>
              <td style={{ backgroundColor: "#d9ead3"}}>Good</td>
              <td style={{ backgroundColor: "#d9ead3"}}>Good</td>
            </tr>
          </table>
        </Card>
      </SoftBox>

      <SoftBox pt={3} pb={3}>
        <SoftBox mb={3}>
          <Card>
            {/* {isLoading?<h1>not ready</h1>:<DataTable table={initialData} /> } */}
            <DataTable fullData={fullData} table={initialData} loading={loading} onClickView={onClickView} />
          </Card>
        </SoftBox>
      </SoftBox>
      <Footer />

      {disclaimerPopup ? <DisclaimerPopup toggleInfoPopup={setDisclaimerPopup}></DisclaimerPopup> : <div></div>}
      {infoPopup ? <OptionInfoPopup toggleInfoPopup={toggleInfoPopup} popupAccessor={popupAccessor} /> : <div></div>}
    </DashboardLayout>
  );
}

export default DataTables;
